import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatListModule } from '@angular/material/list';
import { MatchingPeriodComponent } from '../matchingPeriod/matchingPeriod.component';
import { Observable } from 'rxjs';
import { AuthService } from '../../auth/auth.service';
import { Permission } from '../../interfaces/permission';
import { CommonModule } from '@angular/common';
import { MatchingPeriodService } from '../../services/matchingPeriod.service';

@Component({
  selector: 'app-menu',
  imports: [MatIconModule, MatProgressSpinnerModule, MatListModule, MatchingPeriodComponent, CommonModule],
  templateUrl: './menu.component.html',
  styleUrl: './menu.component.scss'
})
export class MenuComponent {
  // Permissions
  canReadMatchingPeriod: boolean = false;
  isNewsItemAdmin: boolean = false;
  canReadCrossmatches: boolean = false;
  canReadApprovals: boolean = false;
  canReadPairs: boolean = false;
  canReadParticipants: boolean = false;
  canReadTimeline: boolean = false;
  canReadDashboard: boolean = false;
  canAccessCenters: boolean = false;
  canReadHistoricalParticipants: boolean = false;
  canStartMatchrun: boolean = false;
  canAccessEnisSyncLog: boolean = false;
  currentMatchingPeriodId: string = '';
  latestMatchrun: string = '';
  hasMatchingPeriod: boolean = false;
  hasMatchruns: boolean = false;

  constructor(
    private authService: AuthService,
    private matchingPeriodService: MatchingPeriodService
  ) {
    this.loadLatestMatchingPeriod();
  }

  private loadLatestMatchingPeriod(): void {
    this.matchingPeriodService.getLatestMatchingPeriod().subscribe((res) => {
      if (res) {
        //Could maybe use ID instead of mPName, both should technically be unique however only the id is actually enforced.
        //mPName does look prettier in the url.
        this.hasMatchingPeriod = true;
        this.currentMatchingPeriodId = res.matchingPeriodName;
        if (res.matchRuns && res.matchRuns.length > 0) {
          this.hasMatchruns = true;
          this.latestMatchrun = res.matchRuns[res.matchRuns.length - 1].runNumber.toString();
        } else {
          this.hasMatchruns = false;
        }
      }
    });
  }

  ngOnInit(): void {
    this.authService.getAllPermissions$().subscribe((permissions) => {
      this.canReadMatchingPeriod = permissions.includes(Permission.DASHBOARD_CYCLE);
      this.isNewsItemAdmin = permissions.includes(Permission.NEWSITEM_EDIT);
      this.canReadApprovals = permissions.includes(Permission.APPROVAL_PAGE);
      this.canReadCrossmatches = permissions.includes(Permission.CROSSMATCH_PAGE);
      this.canReadDashboard = permissions.includes(Permission.DASHBOARD_READ);
      this.canReadPairs = permissions.includes(Permission.PAIRS_PAGE);
      this.canReadParticipants = permissions.includes(Permission.PARTICIPANTS_PAGE);
      this.canReadTimeline = permissions.includes(Permission.TIMELINE_PAGE);
      this.canAccessCenters = permissions.includes(Permission.CENTERS_PAGE);
      this.canReadHistoricalParticipants = permissions.includes(Permission.PARTICIPANTS_HISTORICAL_PAGE);
      this.canStartMatchrun = permissions.includes(Permission.MATCHRUN_START);
      this.canAccessEnisSyncLog = permissions.includes(Permission.ENISSYNC_VIEW_LOGS);
    });

    // Subscribe to matchrun completion events to refresh the menu
    this.matchingPeriodService.onMatchrunCompleted.subscribe(() => {
      console.log('Matchrun completed - refreshing menu data');
      this.loadLatestMatchingPeriod();
    });
  }
}
